export interface TimeRange {
  from: string; // ISO 8601 timestamp
  to: string;
}

export interface ReportEntityMap {
  workspaceId: string;
  groupId?: string;
  commanderId?: string;
  controlUnitId?: string;
}

export enum CHANNEL_TYPE {
  ANALOG = 'ANALOG',
  DIGITAL = 'DIGITAL',
}
export interface GlobalChannelID {
  /** groupId from the composable device */
  composableDeviceId?: string;
  deviceID: string;
  cuID: string;
  channelID: string;
  type: CHANNEL_TYPE;
}
export interface ChannelMap extends GlobalChannelID {
  minThreshold?: number | null;
  maxThreshold?: number | null;
}

export interface ReportType {
  id: string;
  name: string;
  isDefault: boolean;
  workspaceId: string;
  description?: string;
  anatomyComponents?: string[];
  supportedFormats: ('pdf' | 'csv' | 'json')[];
  mapRenderTemplate?: Record<string, string>;
  labels: Record<string, string>;
}

export interface ReportSpec {
  reportTitle: string;
  reportType?: ReportType | null;
  reportTypeId?: string;
  channels: ChannelMap[];
  intervalTimeInSeconds?: number;
  exportFormats: ('pdf' | 'csv' | 'json')[];
  anatomyComponentsEnabled?: string[];
  labels?: Record<string, string>;
  locales?: string[]; // BCP 47 language tag, e.g. "en", "de", "fr"
  timezone?: string; // IANA timezone name, e.g. "Europe/Berlin". If not provided, the system timezone will be used.
}

export interface ReportRequest extends ReportSpec {
  timeRange: TimeRange;
}

export interface ReportQuery {
  data: Report[];
  count: number;
}
export interface Report extends ReportSpec {
  id: string;
  createdAt: number; // timestamp in ms
  executionState:
    | 'GENERATING'
    | 'RENDERING'
    | 'STORING'
    | 'COMPLETED'
    | 'ERROR';
  files: Record<'pdf' | 'csv' | 'json', string>; // format → URL
  reportScheduleId?: string;
  timeRange: TimeRange;
  sequenceReportValue: number;
}

export interface ReportQueryParams {
  page: number;
  pageSize: number;
  from?: string;
  to?: string;
  reportTypeId?: string;
  reportTypeIds?: string[];
  groupId?: string;
  workspaceId?: string;
  commanderId?: string;
  sortBy?: string;
  sortOrder?: string;
}

export interface ReportSchedule {
  id: string;
  reportEntityMap: ReportEntityMap[];
  intervalType: 'day' | 'week' | 'month' | 'year';
  intervalValue: number;
  startTime: string; // ISO 8601
  reportSpec: ReportSpec;
}

export interface SequenceReport {
  id: string;
  workspaceId: string;
  value: number;
}

export interface ReportResponse {
  files: Record<string, string>; // format → S3 file path with token
}
